import { Slug } from "../constants";
import { getReferralCode } from "../service/CookieService";

export const debounce = (func, waitTime = 1000) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, waitTime);
  };
};

export const throttle = (func, waitTime = 1000) => {
  let timeout;
  return (...args) => {
    // if (args[1] && args[1].tag === "networking") {
    //   console.log("networkfound");
    // }
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null;
      }, waitTime);
      func(...args);
      return true;
    } else {
      return false;
    }
  };
};

export const stringEquals = (str1, str2) => {
  // if one is null, the other can be '' or null
  if (str1 === null || str1 === undefined) {
    return str2 === null || str2 === "" || str2 === undefined;
  }
  if (str2 === null || str2 === undefined) {
    return str1 === null || str1 === "" || str1 === undefined;
  }
  return str1 === str2;
};

export const formatJobDescription = (description) => {
  const maxShowLength = 500;
  let currentLength = 0;
  let showIdx = -1;
  let lastElementShown = -1;
  const jobList = JSON.parse(description);
  const finalList = [];
  // do two things here:
  // 1. merge the 'b' tags if they should be on same line
  //    - or, merge an 'x' into the previous b in certain cases
  // 2. set showIdx to the first index that is over maxShowLength
  let idx = 0;
  jobList.forEach((item, i) => {
    if (i === 0 && item[0] === "x-div") {
      return;
    }

    if (item[0].startsWith("sep-")) {
      finalList.push(["x-div", item[1]]);
    } else if (item[1].length === 0) {
      finalList.push(item);
    } else if (
      (finalList.length > 0 &&
        item[0] === "b" &&
        finalList[finalList.length - 1][0] === "b" &&
        // is punctuation
        (item[1][0] === "," || item[1][0] === " " || item[1][0] === ";")) ||
      item[1][0] !== item[1][0].toUpperCase()
    ) {
      finalList[finalList.length - 1][1] += item[1];
      // } else if (
      //   finalList.length > 0 &&
      //   item[0] === "x" &&
      //   (item[1][0] === "," || item[1][0] === " " || item[1][0] === ";") &&
      //   finalList[finalList.length - 1][0] === "b"
      // ) {
      //   finalList[finalList.length - 1][0] = "b-inline";
    } else {
      finalList.push(item);
    }
    // if we pushed an 'x' item, and the item before that was an 'x-div', push another 'x-div'
    if (
      finalList.length > 1 &&
      finalList[finalList.length - 1][0] === "x" &&
      finalList[finalList.length - 2][0] === "x-div"
    ) {
      finalList.push(["x-div", ""]);
    }
    idx++;
    if (showIdx === -1) {
      currentLength += item[1].length;
      if (currentLength >= maxShowLength) {
        showIdx = idx;
        lastElementShown = item[1].length - (currentLength - maxShowLength);
      }
    }
  });
  return { list: finalList, showIdx: showIdx, lastElementShown };
};

export const getDefaultSurveyFromCookie = () => {
  const token = getReferralCode();
  if (token === null) {
    return Slug.surveyInitial;
  }
  if (token.startsWith("g")) {
    return Slug.surveyGigInitial;
  }
  return Slug.surveyInitial;
};

export const jobIsFetti = (nativeId) => {
  return nativeId.startsWith("fet");
};
export const jobIdToRaw = (jobId) => {
  // currently used for apply.serverCompanyData
  return parseInt(jobId.replace("fet", ""));
};

export const jobIdToUrl = (jobId) => {
  return parseInt(jobId.replace("fet", "")) + 100000;
};

export const jobIdFromUrl = (urlJobId) => {
  return "fet" + (parseInt(urlJobId) - 100000);
};

export const valueToPhoneNumber = (value) => {
  if (!value) return "";
  const phoneNumber = value.toString().replace(/\D/g, "");
  if (phoneNumber.length >= 11) {
    return `+${phoneNumber.slice(0, 1)} (${phoneNumber.slice(
      1,
      4
    )}) ${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7, 11)}`;
  }
  if (phoneNumber.length === 10) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  if (phoneNumber.length >= 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  if (phoneNumber.length >= 4) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}`;
  }
  return phoneNumber;
};

export const fileSizeToString = (sizeStr) => {
  const size = parseInt(sizeStr);
  if (size < 1000) {
    return `${size} bytes`;
  }
  if (size < 1000000) {
    return `${Math.round(size / 1000)} KB`;
  }
  return `${Math.round(size / 1000000)} MB`;
};

export const prettyDate = (time) => {
  // 2023-05-27 22:03:43 -> 1 hour ago
  const date = parseDate(time);
  var diff = (new Date().getTime() - date.getTime()) / 1000,
    day_diff = Math.floor(diff / 86400);
  var year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate();
  if (isNaN(day_diff) || day_diff < 0 || day_diff >= 31)
    return (
      year.toString() +
      "-" +
      (month < 10 ? "0" + month.toString() : month.toString()) +
      "-" +
      (day < 10 ? "0" + day.toString() : day.toString())
    );

  var r =
    (day_diff == 0 &&
      ((diff < 60 && "just now") ||
        (diff < 120 && "1 minute ago") ||
        (diff < 3600 && Math.floor(diff / 60) + " minutes ago") ||
        (diff < 7200 && "1 hour ago") ||
        (diff < 86400 && Math.floor(diff / 3600) + " hours ago"))) ||
    (day_diff == 1 && "Yesterday") ||
    (day_diff < 7 && day_diff + " days ago") ||
    (day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago");
  return r;
};
export const prettyDateShort = (time, compareDate = null) => {
  // 2023-05-27 22:03:43
  const date = parseDate(time);
  compareDate = compareDate ? compareDate : new Date();
  var diff = (compareDate.getTime() - date.getTime()) / 1000,
    day_diff = Math.floor(diff / 86400);
  var year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate();
  if (isNaN(day_diff) || day_diff < 0 || day_diff >= 31) return "";

  var r =
    (day_diff == 0 &&
      ((diff < 60 && Math.floor(diff) + "s") ||
        (diff < 3600 && Math.floor(diff / 60) + "m") ||
        (diff < 86400 && Math.floor(diff / 3600) + "h"))) ||
    (day_diff < 7 && day_diff + "d") ||
    (day_diff < 31 && Math.ceil(day_diff / 7) + "w");
  return r;
};

export const parseDate = (dateStr) => {
  return new Date(dateStr.replace(/-/g, "/").replace(/[TZ]/g, " ") + " UTC");
};

export const recruiterIdToUrl = (id) => {
  return parseInt(id) + 35642;
};

export const recruiterIdFromUrl = (id) => {
  return parseInt(id) - 35642;
};
export const applicationIdToUrl = (id) => {
  return parseInt(id) + 22433;
};

export const applicationIdFromUrl = (id) => {
  return parseInt(id) - 22433;
};

export const UrlParam = {
  // jobId: "jobId",
  recruiterId: "at",
  // applicationId: "an",
};

export const messageDtStr = () => {
  return new Date().toISOString().slice(0, 19).replace("T", " ");
};

export const getLatestId = (allChats) => {
  let latestId = 0;
  allChats.forEach((chat) => {
    // loop through chat.history
    // if message has a localId, skip it
    // if message has an id, compare it to latestId
    chat.history.forEach((message) => {
      console.log("considering message", message);
      if (message.serverId && !message.localId) {
        latestId = Math.max(latestId, message.serverId);
      }
    });
  });
  return latestId;
};

export const fixPathname = (pathname) => {
  if (pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
};

export const isLoggedIn = (auth) => {
  return auth.testing
    ? true
    : auth.accountData.loginToken !== null &&
        auth.accountData.contactInfo !== null;
};
